import { Component, OnInit } from '@angular/core';
import { AppConstants } from '@app/@core/entities/app-constants';
import { AuthService } from '@app/@core/services/auth.service';
import { HttpService } from '@app/@core/services/http.service';
import { PermissionStore } from '@app/@core/store/permission.store';
import { BehaviorSubject, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LocalService } from '@core/services/local.service';
@Component({
  standalone: false,
  selector: 'app-masters',
  templateUrl: './masters.component.html',
  styleUrls: ['./masters.component.scss']
})
export class MastersComponent implements OnInit {
  RBACORG: any;
  PERMISSION: any;
  orgSubs: Subscription;
  mastersEvent$: BehaviorSubject<any>;
  INPUTVALIDATIONMETHOD: any;
  constructor(private permissionStore: PermissionStore, private authService: AuthService, private httpService: HttpService, private sessionStorage: LocalService) {
    this.mastersEvent$ = new BehaviorSubject<any>(null);
    this.orgSubs = this.authService.orgInfo.subscribe(o => {
      console.log('MastersComponent');
      this.PERMISSION = this.permissionStore.state;
      this.INPUTVALIDATIONMETHOD = AppConstants.onInput.bind(this);
      this.RBACORG = {
        tokenKey: 'jwt-token',
        apiHost: environment.apiHost,
        others: this.sessionStorage.asStorage(),
        orgID: o ? o : this.sessionStorage.getItem('orgid'),
        environment: {
          mstrUsername: environment.mstrUsername,
          mstrPassword: environment.mstrPassword,
          mstrURL: environment.mstrURL,
          mstrProjectID: environment.mstrProjectID,
          applicationid: environment.applicationid,
          priority: environment.priority,
          videoConferenceDomain: environment.videoConferenceDomain,
          ChatBotNew: environment.ChatBotNew,
          ChatBot: environment.ChatBot,
          n8nWorflowUrl: environment.n8nWorflowUrl,
          production: environment.production
        }
      };
      this.mastersEvent$.next({
        RBACORG: this.RBACORG,
        PERMISSION: this.PERMISSION,
        HTTPSERVICE: this.httpService,
        INPUTVALIDATIONMETHOD: this.INPUTVALIDATIONMETHOD
      });
    });
  }

  ngOnInit(): void {
    console.log();
  }
  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  ngOnDestroy(): void {
    this.orgSubs.unsubscribe();
  }
}
